import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
})
export class TextareaComponent{

  @Input() formGroup: FormGroup;
  @Input() id: string;
  @Input() name: string;
  @Input() value: string;
  @Input() label: string;
  @Input() placeHolder: string;
  @Input() errorMessage: string;
  @Input() submitted: boolean;

  getControl(): AbstractControl {
    return this.formGroup.get(this.name);
  }

}
